export default __webpack_public_path__ + "images/7c0a3a93b37dce824b8a431681f89a73-3-good-things.svg";